import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/gallery";

export const uploadGalleryImage = ({
  image,
  event_id,
  caption,
  order,
} = {}) => {
  const formData = new FormData();
  formData.append("image", image);

  if (event_id !== undefined && event_id !== null && event_id !== "") {
    formData.append("event_id", event_id);
  }
  if (caption !== undefined && caption !== null && caption !== "") {
    formData.append("caption", caption);
  }
  if (order !== undefined && order !== null && order !== "") {
    formData.append("order", String(order));
  }

  return jeepRallyApi.post(baseUrl, formData);
};
